import axios from "axios";
import { UserEvent, LeadType } from "../Constants/userEventEnums";
import { trackEvent } from "./analytics";

const API_URL = process.env.NEXT_PUBLIC_MARKETPLACE_API_URL;

const postUserEvent = async (eventObject: Record<string, any>) => {
  try {
    await axios.post(`${API_URL}/user-events`, JSON.stringify(eventObject), {
      headers: { "Content-Type": "application/json" },
    });
  } catch (error) {
    console.error("Error tracking user event:", error);
  }
};

export const trackListingVisit = async (listing_id: number, userId?: string,location:string, title?: string, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.LISTING_VISIT,
    listing_id,
    fk_user_id: userId,
    is_guest: isGuest,
    location:location
  };
  trackEvent(UserEvent.LISTING_VISIT, { value: listing_id, action: "click", Listing_title: title, url });
  await postUserEvent(eventData);
};

export const trackStoreVisit = async (shop_id: number, userId?: string, location?: string,shop_name?: string, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.STORE_VISIT,
    shop_id,
    fk_user_id: userId,
    is_guest: isGuest,
    location:location
  };
  trackEvent(UserEvent.STORE_VISIT, { value: shop_name, action: "click",location:location, shopId: shop_id, url });
  await postUserEvent(eventData);
};

export const trackCategoryClick = async (category_id: number, userId?: string,location:string, categoryName?: string, url?: string,) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.CATEGORY_CLICK,
    category_id,
    fk_user_id: userId,
    location: location,
    categoryName:categoryName,
    is_guest: isGuest,
    url:url
  };
  trackEvent(UserEvent.CATEGORY_CLICK, { value: categoryName, action: "click", category_id, url });
  await postUserEvent(eventData);
};

export const trackSpecsClick = async (spec_id: number, userId?: string, location?:string, specName?: string, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.SPECS_CLICK,
    spec_id,
    specName: specName,
    location: location,
    fk_user_id: userId,
    is_guest: isGuest,
  };
  trackEvent(UserEvent.SPECS_CLICK, { value: specName, action: "click", spec_id,location, url });
  await postUserEvent(eventData);
};

export const trackSpecsCategoryClick = async ( spec_category_id: number, userId?: string,location?:string, categoryName?: string, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.SPECS_CATEGORY_CLICK,
    spec_category_id: spec_category_id,
    location: location,
    categoryName:categoryName,
    fk_user_id: userId,
    is_guest: isGuest,
  };
  trackEvent(UserEvent.SPECS_CATEGORY_CLICK, { value: categoryName, action: "click", spec_category_id, url });
  await postUserEvent(eventData);
};

export const trackModelVisit = async (model_id: number, userId?: string,category?: string, modelName?: string, url?: string) => {
  const isGuest = !userId;
  
  const eventData = {
    event_name: UserEvent.MODEL_VISIT,
    model_id: model_id,
    fk_user_id: userId,
    category: category,
    modelName: modelName,
    url: url,

    is_guest: isGuest,
  };
  trackEvent(UserEvent.MODEL_VISIT, { value: modelName, action: "click", model_id, url });
  await postUserEvent(eventData);
};

export const trackAddToCart = async (listing_id: number, userId?: string, price?: number, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.ADD_TO_CART,
    listing_id,
    fk_user_id: userId,
    is_guest: isGuest,
  };
  trackEvent(UserEvent.ADD_TO_CART, { value: price, currency: "PKR", listing_id, url });
  await postUserEvent(eventData);
};

export const trackBuyNow = async (listing_id: number,Listing_title: string, userId?: string, shop_id?: number, shop_name?: string, price?: number, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.BUY_NOW,
    listing_id,
    fk_user_id: userId,
    shop_id,
    shop_name: shop_name,
    Listing_title: Listing_title,
    price:price,
    url: url,

    is_guest: isGuest,
  };
  trackEvent(UserEvent.BUY_NOW, { value: price, currency: "PKR", listing_id, url });
  await postUserEvent(eventData);
};

export const trackCheckout = async (userId: string, order_id: string, total_price: number, url?: string,trx_method:string) => {
    const isGuest = !userId;

  const eventData = {
    event_name: UserEvent.CHECKOUT,
    fk_user_id: userId,
    order_id,
    total_price,
    is_guest: isGuest,
    transaction_method: trx_method, // Possible values: cash, card, paypal, etc.  // TODO: Add more transaction methods as required. For example, Stripe, PayPal, etc.  // Note: This is just a placeholder. Replace it with the actual transaction method used in your application.  // Also, ensure that you have a separate endpoint in your server-side code to handle the transaction data.  // For example, you can create a new endpoint in


  };
  trackEvent(UserEvent.CHECKOUT, { value: total_price, currency: "PKR", order_id, url });
  await postUserEvent(eventData);
};

export const trackReserve = async (listing_id: number, title: string, userId?: string, price?: number,shop_id?: number,shop_name?: string, url?: string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: UserEvent.RESERVE,
    fk_user_id: userId,
    listing_id,
    is_guest: isGuest,
    shop_id,
    shop_name
  };
  trackEvent("dry_conversion", {
    value: price,
    currency: "PKR",
    items: [{ item_id: listing_id, item_name: title, price }],
    url,
  });
  await postUserEvent(eventData);
};

export const trackContact = async (shop_id: number, userId?: string, leadType?: LeadType, phoneNumber?: string, url?: string,shop_name:string) => {
  const isGuest = !userId;
  const eventData = {
    event_name: leadType === LeadType.PHONE ? UserEvent.CONTACT_PHONE : UserEvent.CONTACT_WHATSAPP,
    shop_id,
    fk_user_id: userId,
    is_guest: isGuest,
    phone_number: phoneNumber,
    shop_name: shop_name,
  };
  trackEvent("lead", { value: phoneNumber, leadType, url,shop_name });
  await postUserEvent(eventData);
};

export const trackOTPSent = async (userId?: string, phoneNumber?: string,shop_name?:string) => { 
    const isGuest = !userId;

  const eventData = {
    event_name: UserEvent.OTP_SENT,
    fk_user_id: userId,
    phone_number: phoneNumber,
    shop_name: shop_name,
    is_guest: isGuest,
  };
  await postUserEvent(eventData);
}

export const trackOTPVerified = async (userId: string, phoneNumber: string, shop_name) => {
      const isGuest = !userId;

  const eventData = {
    event_name: UserEvent.OTP_VERIFIED,
    fk_user_id: userId,
    phone_number: phoneNumber,
    shop_name: shop_name,
    is_guest: isGuest,
  };
  await postUserEvent(eventData);
}